import { FavoriteSearchPayload } from '@/lib/api-gluglu-auth'
import { FavouriteSearchOrigin } from '@/lib/api-gluglu-open'
import { ListingCate } from '@/page-commons/listingBySlug'
import { GeoFilter } from '@/types/filter'
import { Filter } from '@/types/graphql-generated-types'

import { getPriceMinCents, getPriceMaxCents } from '../Content/ListingContact/SaveSearchDetail'

import { mapForFavoriteSearch } from './helper-map-filters'

type Props = {
  actualZoneFilterAreas?: GeoFilter[]
  email?: string
  filters?: Filter
  geoSlugs?: string[]
  listing?: ListingCate
  origin: FavouriteSearchOrigin
  referenceCitySlug: string
}

export const createPayload = ({
  actualZoneFilterAreas,
  email,
  filters,
  geoSlugs,
  listing,
  origin,
  referenceCitySlug,
}: Props): FavoriteSearchPayload => {
  if (origin === 'SEARCH_RESULTS') {
    const actualZoneFilterSlugs = actualZoneFilterAreas?.map(({ slug }) => slug) || []
    const favoriteSearchFilters = mapForFavoriteSearch(filters)

    return {
      email,
      origin: 'SEARCH_RESULTS',
      searchCriteria: {
        geoSlugs: actualZoneFilterSlugs.length > 0 ? actualZoneFilterSlugs : geoSlugs,
        referenceCitySlug,
        ...favoriteSearchFilters,
      },
    }
  }

  return {
    email: email,
    origin: 'LISTING_CONTACT',
    searchCriteria: {
      geoSlugs: listing.detail.zone ? [listing.detail.zone.slug] : [listing.detail.city],
      onlyCasavo: false,
      price: {
        from: listing.detail.sellingPrices && getPriceMinCents(listing.detail.sellingPrices.cents) / 100,
        to: listing.detail.sellingPrices && getPriceMaxCents(listing.detail.sellingPrices.cents) / 100,
      },
      referenceCitySlug,
      rooms: {
        from: listing.characteristics.rooms,
        to: listing.characteristics.rooms,
      },
    },
  }
}
